import React from "react";
import { OptimizedGantt, WbsConfiguration } from "@planzone/dto";
import { Props } from "./types";

const Context = React.createContext<{
  hoveredElement?: OptimizedGantt[number] | null;
  configuration?: WbsConfiguration[number]["columns"];
  style: Props["style"];
}>({
  configuration: [],
  style: {},
});

export { Context };
